// Keep purchase flows for future use, but hide them throughout the free service.
module.exports = Object.freeze({ payments: false })
